// Copyright 1999-2021. Plesk International GmbH. All rights reserved.
module.exports = {
  CLS_PREFIX: 'pul-',
  Z_INDEX_POPOVER: 1035,
  Z_INDEX_DROPDOWN: 1035,
  Z_INDEX_OVERLAY: 1050,
  Z_INDEX_TOASTER: 1055,
  Z_INDEX_TOOLTIP: 1060
};